import { createContext as rCreateContext, useContext } from 'react';

/**
 * A helper to create a Context and Provider with no upfront default value, and
 * without having to check for undefined all the time.
 *
 * from https://github.com/typescript-cheatsheets/react-typescript-cheatsheet#context
 */
export const createContext = <A>(contextName: string) => {
  const ctx = rCreateContext<A | undefined>(undefined);
  function useCtx() {
    const c = useContext(ctx);
    if (c === undefined)
      throw new Error(`${contextName} must be inside a Provider with a value`);

    return c;
  }

  return [useCtx, ctx.Provider] as const; // 'as const' makes TypeScript infer a tuple
};
